module.exports = __webpack_public_path__ + "img/2-2.2c3eef59.jpg";